// @flow
import * as actionTypes from './actions';
import type { Action } from './actions';
import initialState from 'store/initialState';

export default function reducer(
  state: string = initialState.ui.theme,
  action: Action
): string {
  switch (action.type) {
    case actionTypes.SET_THEME:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/ui/theme/reducer.js